module.exports = __webpack_public_path__ + "static/media/iconoon.6440622a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/iconoon.ttf?8pq8ff
// module id = 1674
// module chunks = 2